import { action } from 'src/store/common';

export const ActionTypes = {
  SET_GLOBAL_GRID: '[GRID]SET_GLOBAL_GRID',
  SET_GRID_CONTAINER_WIDTH: '[GRID]SET_GRID_CONTAINER_WIDTH',
};

export const Actions = {
  setGridContainerWidth: action(ActionTypes.SET_GRID_CONTAINER_WIDTH),
};
